import { useMemo } from 'react';
import { useScrollTrigger, alpha } from '@mui/material';

function useGlassStyles(theme) {
    const scrolled = useScrollTrigger({ threshold: 1, disableHysteresis: true });

    // estilos cuando NO hay scroll y cuando SÍ hay scroll
    return useMemo(() => {
        const bg = scrolled ? alpha(theme.palette.navigation.main, 0.6) : theme.palette.navigation.main;
        return {
            backgroundColor: bg,
            backdropFilter: 'saturate(180%) blur(20px)',
            WebkitBackdropFilter: 'saturate(180%) blur(20px)',
            boxShadow: scrolled ? '0 4px 16px rgba(0,0,0,0.18)' : 'none',
            transition: 'background-color .2s ease, box-shadow .2s ease, border-color .2s ease',
        };
    }, [scrolled, theme]);
}

export default useGlassStyles;
